import React from 'react';
import PropTypes from 'prop-types';

import SessionItem from './SessionItem';

import aeImageOne from '../images/ae_nts_session_digital_01.jpg';
import aeImageTwo from '../images/ae_nts_session_digital_02.jpg';
import aeImageThree from '../images/ae_nts_session_digital_03.jpg';
import aeImageFour from '../images/ae_nts_session_digital_04.jpg';

const sessionArtworks = [aeImageOne, aeImageTwo, aeImageThree, aeImageFour];

class SessionItems extends React.Component {
    componentDidMount() {
        this.props.sessionBroadcastManager.onLiveBroadcastChange((newLiveBroadcast) => {
            // Below forces re-render of session items.
            this.setState({
                liveBroadcast: newLiveBroadcast,
            })
        });
    }

    render() {
        return this.props.sessionBroadcastManager.broadcasts.slice(0,4).map((broadcast, i) => (
            <SessionItem className={`session-item--${i+1}`} session={broadcast} key={i} shopBundleUrl={this.props.shopBundleUrl}
                         artwork={sessionArtworks[i]}/>
        ));
    }
}

SessionItems.propTypes = {
    sessionBroadcastManager: PropTypes.object.isRequired,
    shopBundleUrl: PropTypes.string.isRequired,
};

export default SessionItems;



// WEBPACK FOOTER //
// ./src/components/SessionItems.jsx